import { render, staticRenderFns } from "./LocalCategoriesTable.vue?vue&type=template&id=659d475c&"
import script from "./LocalCategoriesTable.vue?vue&type=script&lang=js&"
export * from "./LocalCategoriesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports